import { apis } from 'ui-common'
import endpoints from 'ui-common/lib/constants/endpoints.json'

export default {
  submitScreener: (screenerData: any) =>
    apis.$post(endpoints.screeners.store, screenerData)
}
